<!-- 批量更新库存信息 -->
<template>
    <div class="xform">
        <el-row :gutter="10" type="flex" justify="space-between" align="center" >
            <el-col :span="9">
                <el-select v-model="type" size="mini" clearable :placeholder="msg('请选择')" @change="getSelectes">
                    <template v-for="(t, idx) in types">
                        <el-option v-if="hasPermission(t.auth)" :label="t.label" :value="idx" :key="idx"></el-option>
                    </template>
                </el-select>
            </el-col>
            <el-col :xs="15">
                <div style="display:flex;">
                    <div style="white-space:nowrap;">{{msg('批量填充')}}： </div>
                    <el-autocomplete v-if="type == 3" size="mini"
                        v-model="iptLabel"
                        :fetch-suggestions="querySearch"
                        placeholder="输入要填充的值"
                        :trigger-on-focus="false"
                        @select="handleSelect"
                    ></el-autocomplete>
                    <el-select v-else-if="[0].indexOf(type)>-1" placeholder="请选择仓位" v-model="iptValue" clearable  size="small">
                            <el-option
                            v-for="item in stores"
                            :key="item.id" 
                            :label="item.name"
                            :value="item.id"> 
                        </el-option>
                    </el-select>
                    <el-autocomplete v-else-if="type == 8" size="mini"
                        v-model="iptLabel"
                        :fetch-suggestions="querySearchStore"
                        placeholder="输入要填充的值"
                        :trigger-on-focus="false"
                        @select="handleSelectStore"
                    ></el-autocomplete>
                    <el-select v-else-if="[4,5,7].indexOf(type)>-1" 
                        size="mini" :placeholder="msg('请选择')" v-model="iptValue">
                        <el-option v-for="item in selectes" :label="item.label" :value="item.value" :key="item.value"></el-option>
                    </el-select>
                    <el-date-picker v-else-if="[6].indexOf(type)>-1" v-model="iptValue" size="mini"
                        type="date" value-format="yyyy-MM-dd"
                    >
                    </el-date-picker>
                    <el-input v-else style="max-width:200px;"
                        size="mini" :placeholder="msg('输入要填充的值')" v-model="iptValue" >
                    </el-input>
                    <!-- <el-button size="mini" icon="el-icon-check" @click="fillValue"></el-button> -->
                </div>
            </el-col>
        </el-row>
        <div style="display:flex;margin-top:20px;margin-bottom:10px;align-items:center;justify-content:center;">
            <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定更新')}}</span></el-button>
            <el-checkbox style="margin-left:10px;" v-model="isShowTable">查看列表</el-checkbox>
        </div>
        <div class="table-wrap" v-if="isShowTable">
            <vxe-table :data="datas"
                    export-config stripe
                    resizable border="full"
                    highlight-current-row highlight-hover-column highlight-current-column
                    show-overflow show-header-overflow 
                    :height="docHeight" 
                    :scroll-y="{gt: 50}"
                    style="width: 100%" ref="dataTable" >
                <vxe-table-column field="id" :title="msg('ID')" width="80" sortable></vxe-table-column>
                <vxe-table-column field="key" :title="msg('订单编号')" min-width="120" :show-overflow-tooltip="true"></vxe-table-column>
                <vxe-table-column field="value" :title="msg('数据')" min-width="150" >
                    <template v-slot="{ row }">
                        <el-autocomplete v-if="type == 3" size="mini"
                            v-model="row.label"
                            :fetch-suggestions="querySearch"
                            placeholder="输入要填充的值"
                            :trigger-on-focus="false"
                            @select="(item) => handleSelect(item, row)"
                        ></el-autocomplete>
                        <el-select v-else-if="[0].indexOf(type)>-1" placeholder="请选择仓位" v-model="row.value" clearable  size="small">
                                <el-option
                                v-for="item in stores"
                                :key="item.id" 
                                :label="item.name"
                                :value="item.id"> 
                            </el-option>
                        </el-select>
                        <el-autocomplete v-else-if="type == 8" size="mini"
                            v-model="row.label"
                            :fetch-suggestions="querySearchStore"
                            placeholder="输入要填充的值"
                            :trigger-on-focus="false"
                            @select="(item) => handleSelectStore(item, row)"
                        ></el-autocomplete>
                        <el-select v-else-if="[4,5,7].indexOf(type)>-1" 
                            size="mini" :placeholder="msg('请选择')" v-model="row.value">
                            <el-option v-for="item in selectes" :label="item.label" :value="item.value" :key="item.value"></el-option>
                        </el-select>
                        <el-date-picker v-else-if="[6].indexOf(type)>-1" v-model="row.value" size="mini"
                            type="date" value-format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                        <el-input v-else
                            size="mini" :placeholder="msg('输入要填充的值')" v-model="row.value"  >
                        </el-input>
                    </template>
                </vxe-table-column>
                <vxe-table-column field="result"  min-width="200" header-align="right">
                    <!-- <template slot="header">
                        <el-button type="primary" size="mini"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('确定更新')}}</span></el-button>
                    </template> -->
                </vxe-table-column>
            </vxe-table>
        </div>
    </div>
</template>

<script>
export default {
    name: "BatchUpdate",
    components: {
    },
    computed: {
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 220;
            }
        },
    },
    mounted(){
    },
    data(){
        return {
            type: null,
            types: [
                {label: this.msg('仓库'), auth: 'stock:batchFieldStore'},    //0
                {label: this.msg('备注'), auth: 'inventory:batchFieldRemark1'},    //1
                {label: this.msg('说明'), auth: 'inventory:batchFieldRemark2'},    //2
                {label: this.msg('归属人'), auth: 'inventory:batchFieldOwner'},  //3
                {label: this.msg('仓储类型'), auth: 'inventory:batchFieldStoreType'},       //4
                {label: this.msg('仓储状态'), auth: 'inventory:batchFieldStoreType'},       //5
                {label: this.msg('保管期限'), auth: 'inventory:batchFieldExpire'},    //6
                {label: this.msg('弃件处理'), auth: 'inventory:batchFieldQijian'},   //7
                {label: this.msg('库存仓库'), auth: 'stock:batchFieldKucun'},    //8
                {label: this.msg('库存架位'), auth: 'stock:batchFieldShelfCode'},//9
                {label: this.msg('SKU'), auth: 'inventory:batchFieldRemark1'},//10
                {label: this.msg('货号'), auth: 'inventory:batchFieldRemark1'},//11
                {label: this.msg('成本'), auth: 'inventory:batchFieldRemark1'},//12
            ],
            iptValue: null,
            iptLabel: null,
            selectes: [],
            valueSelectes:[],
            stores:[],
            isShowTable:false,
            expCompanys:[],
        }
    },
    props:{
        datas: Array
    },
    methods:{
        getStores(){
            //获取仓库列表
            this.$axios.get(this.$kit.api.store.listUsed)
                .then((result) => {
                    if(result.status){
                        let data = result.data;
                        // data.splice(0, 0, {id: 0, name: '空'});
                        this.stores.splice(0,this.stores.length);
                        this.stores = data;
                    }
                });
        },
        getStoresOwner(){
            //获取仓库列表
            this.$axios.get(this.$kit.api.store.listByUsedOwner)
                .then((result) => {
                    if(result.status){
                        let data = result.data;
                        // data.splice(0, 0, {id: 0, name: '空'});
                        this.stores.splice(0,this.stores.length);
                        this.stores = data;
                    }
                });
        },
        querySearchStore(queryString, cbFn){  //搜索仓库
            this.$axios.get(this.$kit.api.store.listByUsedOwner+"?name="+encodeURIComponent(queryString))
                .then((result) => {
                    if(result.status){
                        this.stores.splice(0,this.stores.length);
                        result.data.forEach(e => {
                            this.stores.push({
                                id: e.id,
                                value: e.name
                            });
                        });
                        cbFn(this.stores);
                    }
                });
        },
        fillValue(){
            this.datas.forEach(d => {
                d.label = this.iptLabel;
                d.value = this.iptValue;
            })
        },
        getSelectes(idx){
            this.iptValue = null;
            this.iptLabel = null;

            this.datas.forEach(d => {
                d.value = null;
                d.label = null;
                d.result = null;
            });

            if(this.type == 4){//仓储类型
                //去选中订单的仓库设置的所有仓储类型
                // this.selectes = this.dicts.inventoryStoreTypes;
                this.getStoreTypesByStore();
            }else if(this.type == 7){
                this.selectes = [
                    {label: "已弃件", value: 135, type: "primary"},
                ]
            }else if(this.type == 0){
                this.getStores();
            }else if(this.type == 8){
                this.getStoresOwner();
            }else if(this.type == 5){//仓储状态
                this.selectes = this.dicts.inventoryBatchUpdateStatuses;
            }
            return [];
        },
        querySearch(queryString, cbFn){  //搜索用户
            this.$axios.get(this.$kit.api.user.search+"?name="+encodeURIComponent(queryString)+"&type=1")
                .then((result) => {
                    if(result.status){
                        let users =[];
                        result.data.forEach(e => {
                            users.push({
                                id: e.id,
                                value: e.value
                            });
                        });
                        cbFn(users);
                    }
                });
        },
        getStoreTypesByStore(){//获取所选库存对应的仓库设置的所有仓储类型
            let ids = this.datas.map(s => s.id).join(",");
            this.$axios.post(this.$kit.api.inventory.getStoreTypesByStore, ids)
                .then((result) => {
                    if(result.status){
                        let data = result.data;
                        this.selectes = [];
                        if(data.length > 0){
                            data.forEach(e => {
                                let storeType = this.dicts.inventoryStoreTypes.find(d => d.value === +e);
                                this.selectes.push(storeType);
                            })
                        }else{
                            this.$message(this.msg('只能选择同仓库的数据'));
                        }
                    }else{
                        this.$message(result.msg);
                    }
                });
        },
        handleSelect(item, row) { //获取选中值
            if(row){
                row.value = item.id,
                row.label = item.value
            }else{
                this.iptValue = item.id;
                this.iptLable = item.value;
            }
        },
        handleSelectStore(item, row) { //获取选中值
            if(row){
                row.value = item.id,
                row.label = item.name
            }else{
                this.iptValue = item.id;
                this.iptLable = item.name;
            }
        },
        onSubmit(){

            this.fillValue();

            let ds = [];
            this.datas.forEach(d => {
                ds.push({
                    id: d.id,
                    value: d.value
                });
            });
            var _this = this;
            this.$axios.post(this.$kit.api.inventory.batchUpdate+"?t="+this.type, ds)
                .then((result) => {
                    this.$message(result.msg || _this.msg('更新失败'));

                    if(result.status){
                        // _this.$message(result.msg || _this.msg('更新成功'));
                        for(let i = 0; i<result.data.length; i++){
                            this.datas[i].result = result.data[i];
                        }
                    }
                });
        },
    }
}
</script>

<style lang="scss" scoped>
.xform{
    box-sizing: border-box;
}
.xctrl{
    text-align:center;
    padding:15px;
    width:100%;
}

</style>